module.exports = __webpack_public_path__ + "static/assets/153f207c1b27eff452e2e136af72b4a3.png";